import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: any) => ({
  container: {
    position: "fixed",
    top: 0,
    left: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",

    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: theme.whiteColor,
      opacity: 0.5,
    },
  },
  loading: (props: any) => ({
    margin: `${props.marginTop || 0} ${props.marginRight || "auto"} ${
      props.marginBottom || 0
    } ${props.marginLeft || "auto"}`,
    color:
      props.color === undefined || props.color === null
        ? theme.lightPinkColor
        : props.color,
  }),
}));

export default useStyles;
